import React from "react";
import { RecipeUnit } from "./productRecipeApi";
import { Draft, unitsFor } from "./productRecipeEditor";
import RecipeFieldError, {
  RecipeErrors,
  recipeFieldProps,
} from "./RecipeFieldError";
import { control } from "./recipeStyles";
interface Props {
  draft: Draft;
  productSellingUnit: number;
  disabled: boolean;
  errors: RecipeErrors;
  change: (values: Partial<Draft>) => void;
}
export default function RecipeOutput({
  draft,
  productSellingUnit,
  disabled,
  errors,
  change,
}: Props) {
  const errorFor = (field: string) => (
    <RecipeFieldError field={field} errors={errors} />
  );
  const propsFor = (field: string) => recipeFieldProps(field, errors);
  return (
    <div className="rounded-lg border border-slate-200 bg-slate-50 px-4 py-3">
      <div className="flex flex-wrap items-center gap-2">
        <span className="text-sm font-medium text-slate-600">To produce</span>
        <div className="w-24">
          <label htmlFor="recipe-output-quantity" className="sr-only">
            Output quantity
          </label>
          <input
            id="recipe-output-quantity"
            type="number"
            min="0.0001"
            step={draft.outputUnit === "pieces" ? "1" : "0.0001"}
            value={draft.outputQuantity}
            disabled={disabled}
            onChange={(event) => change({ outputQuantity: event.target.value })}
            className={`${control} text-right font-semibold tabular-nums`}
            {...propsFor("output_quantity")}
          />
        </div>
        <div className="w-28">
          <label htmlFor="recipe-output-unit" className="sr-only">
            Output unit
          </label>
          <select
            id="recipe-output-unit"
            value={draft.outputUnit}
            disabled={disabled}
            onChange={(event) =>
              change({ outputUnit: event.target.value as RecipeUnit })
            }
            className={control}
            {...propsFor("output_unit")}
          >
            {Array.from(
              new Set([...unitsFor(productSellingUnit), draft.outputUnit])
            ).map((unit) => (
              <option key={unit}>{unit}</option>
            ))}
          </select>
        </div>
      </div>
      {errorFor("output_quantity")}
      {errorFor("output_unit")}
    </div>
  );
}
